import { EDIT_ACCESSIBILITY } from 'shared/constants/permissions';
import Checklist from './Checklist';
import Findings, { FindingDetail } from './Findings';
import ManualReview from './ManualReview';
import Overview from './Overview';
import Pages from './Pages';
import Scans from './Scans';
import Settings from './Settings';
import { FINDING_SUITES } from './utils';

const routes = [{
  path: 'overview',
  label: 'Overview',
  component: Overview,
}, {
  path: 'findings',
  label: 'Findings',
  link: false,
  defaultOpen: true,
  children: FINDING_SUITES.map(suite => ({
    path: suite.path,
    label: suite.label,
    component: Findings,
  })),
}, {
  path: 'findings/:suitePath/:findingId',
  component: FindingDetail,
}, {
  path: 'pages',
  label: 'Pages & PDFs',
  component: Pages,
}, {
  path: 'manual-review',
  label: 'Manual review',
  component: ManualReview,
}, {
  path: 'checklist',
  label: 'WCAG checklist',
  component: Checklist,
}, {
  path: 'sync-history',
  label: 'Scans',
  component: Scans,
}, {
  path: 'settings',
  label: 'Settings',
  component: Settings,
  permission: EDIT_ACCESSIBILITY,
}];

export default routes;
